import { IAccount } from '@site-mate/sitemate-global-shared';
import { queryOptions } from '@tanstack/react-query';

import { ACCOUNT_LAYER_ROLES } from '@/components/workspace-switcher/workspace-switcher-menu.utils';
import { accountService } from '@/services/global-api/account.service';
import { IPermissionDto, permissionService } from '@/services/global-api/permission.service';

export const workspaceSwitcherAccountKeys = {
  all: ['workspace-switcher-account'] as const,
  detail: (accountId: string) => [...workspaceSwitcherAccountKeys.all, accountId] as const,
};

export const workspaceSwitcherPermissionsKeys = {
  all: ['workspace-switcher-permissions'] as const,
  list: (params?: { includeRoles?: string[] }) => [...workspaceSwitcherPermissionsKeys.all, params] as const,
};

export const getAccountQueryOptions = (accountId: string) => {
  return queryOptions<IAccount | null>({
    queryKey: workspaceSwitcherAccountKeys.detail(accountId),
    queryFn: () => accountService.getAccountById(accountId),
    staleTime: 5 * 60 * 1000,
  });
};

export const getMyPermissionsQueryOptions = (params?: { includeRoles?: string[] }) => {
  return queryOptions<IPermissionDto[]>({
    queryKey: workspaceSwitcherPermissionsKeys.list(params),
    queryFn: () => permissionService.listMyPermissions(params),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};

export const getAccountLayerPermissionsQueryOptions = () => {
  return queryOptions<IPermissionDto[]>({
    queryKey: workspaceSwitcherPermissionsKeys.list({ includeRoles: ACCOUNT_LAYER_ROLES }),
    queryFn: () => permissionService.listMyPermissions({ includeRoles: ACCOUNT_LAYER_ROLES }),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
